module.exports = __webpack_public_path__ + "static/media/onboarding-theme.40c664aa.gif";